import { render } from "./DetailSearchInvoiceWPOProc.vue?vue&type=template&id=33568c1f&scoped=true"
import script from "./DetailSearchInvoiceWPOProc.vue?vue&type=script&lang=js"
export * from "./DetailSearchInvoiceWPOProc.vue?vue&type=script&lang=js"

import "./DetailSearchInvoiceWPOProc.vue?vue&type=style&index=0&id=33568c1f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33568c1f"]])

export default __exports__